// File: /src/hooks/useSortableData.js

import { useState, useMemo } from 'react';

export const useSortableData = (
	items,
	config = { key: 'id', direction: 'asc' }
) => {
	const [sortConfig, setSortConfig] = useState(config);

	const handleSort = (key) => {
		let direction = 'asc';
		if (sortConfig.key === key && sortConfig.direction === 'asc') {
			direction = 'desc';
		}
		setSortConfig({ key, direction });
	};

	// Ordenar dados de acordo com a configuração atual
	const sortedItems = useMemo(() => {
		if (!items || items.length === 0) return [];

		const sortableItems = [...items];
		sortableItems.sort((a, b) => {
			let aVal = a[sortConfig.key];
			let bVal = b[sortConfig.key];

			if (typeof aVal === 'string') {
				aVal = aVal.toLowerCase();
				bVal = bVal.toLowerCase();
			}

			if (aVal < bVal) {
				return sortConfig.direction === 'asc' ? -1 : 1;
			}
			if (aVal > bVal) {
				return sortConfig.direction === 'asc' ? 1 : -1;
			}
			return 0;
		});

		return sortableItems;
	}, [items, sortConfig]);

	return { sortedItems, sortConfig, handleSort };
};

export default useSortableData;
